export const getCheckboxIconName = state => {
	switch (state) {
		case 'indeterminate':
			return 'checkbox-indeterminate-filled'
		case 'checked':
			return 'checkbox-checked-colored'
		case 'unchecked':
		default:
			return 'checkbox-unchecked'
	}
}
